export default "__VITE_ASSET__tEpDWwSc__"